import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class UserService {

    getIframes(token, params) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/iframes',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                params: params
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getIframe(token, iframeID) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/iframes/' + iframeID,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


    postIframe(token, data) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/iframes',
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putIframe(token, iframeID, data) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/iframes/' + iframeID,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteIframe(token, iframeID) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/iframes/' + iframeID,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


}